import { useTheme } from '@kidzonet/naiveui-use-theme'

const primary50 = '#e8e9ed'
const primary100 = '#b8bbc6'
const primary200 = '#959aaa'
const primary300 = '#656c83'
const primary400 = '#474f6b'
const primary500 = '#192346'
const primary600 = '#172040'
const primary700 = '#121932'
const primary800 = '#0e1327'
const primary900 = '#0b0f1d'

const secondary50 = '#e9f2f6'
const secondary100 = '#b9d5e3'
const secondary200 = '#98c1d5'
const secondary300 = '#68a5c2'
const secondary400 = '#4b94b6'
const secondary500 = '#1e79a4'
const secondary600 = '#1b6e95'
const secondary700 = '#155674'
const secondary800 = '#11435a'
const secondary900 = '#0d3345'

const neutral50 = '#f0f1f3'
const neutral100 = '#d0d3d9'
const neutral200 = '#b9bdc7'
const neutral300 = '#989fad'
const neutral400 = '#858d9d'
const neutral500 = '#667085'
const neutral600 = '#5d6679'
const neutral700 = '#48505e'
const neutral800 = '#383e49'
const neutral900 = '#101116'

const primary = primary500
const secondary = secondary500

const mainMenuText = '#D0D3D9'

const defaultColors = {
    primary50,
    primary100,
    primary200,
    primary300,
    primary400,
    primary500,
    primary600,
    primary700,
    primary800,
    primary900,
    secondary50,
    secondary100,
    secondary200,
    secondary300,
    secondary400,
    secondary500,
    secondary600,
    secondary700,
    secondary800,
    secondary900,
    neutral50,
    neutral100,
    neutral200,
    neutral300,
    neutral400,
    neutral500,
    neutral600,
    neutral700,
    neutral800,
    neutral900,
}

export default {
    defaultTheme: useTheme(),
    themes: {
        light: {
            dark: false,
            colors: {
                ...defaultColors,
                primary,
                defaultPrimary: '#62269E',
                secondary,
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#561fa1',
                success: '#4CAF50',
                warning: '#FFC107',
                background: '#fafafa',
                switcher: primary,
                mainMenu: primary,
                tabs: primary,
                floatingActionButton: primary,
                primaryButton: primary,
                purpleButton: primary,
                mainMenuText,
                mainMenuActiveText: secondary900,
                mainMenuActiveIcon: secondary900,
                mainContentBackground: neutral50,
                mainMenuActiveItem: neutral50,
                subHeader: '#888C9A',
                tableFooter: primary100,
                oppositePrimary: '#fff',
                mainMenuActive: '#fff',
                mainMenuIcon: mainMenuText,
                tableAccent: secondary,
                tableContent: neutral900,
                accountMenu: neutral900,
                accountMenuIcon: '#fff',
            },
        },
        dark: {
            dark: true,
            colors: {
                ...defaultColors,
                mainMenu: primary,
                mainMenuText,
                mainMenuActiveText: neutral100,
                primary: '#fff',
                secondary: primary700,
                floatingActionButton: primary700,
                primaryButton: primary700,
                purpleButton: primary,
                mainContentBackground: primary900,
                mainMenuActiveItem: primary900,
                mainMenuIcon: mainMenuText,
                mainMenuActiveIcon: secondary500,
                tableFooter: primary500,
                oppositePrimary: primary,
                mainMenuActive: '#fff',
                tableAccent: secondary,
                defaultPrimary: '#fff',
                tableContent: neutral100,
                accountMenu: primary600,
                accountMenuIcon: mainMenuText,
                surface: primary600,
            },
        },
    },
}
